// extracted by mini-css-extract-plugin
export default {"colorBox":"Reports_colorBox__F5Jt+","boxText":"Reports_boxText__JhiMi"};